import PropTypes from 'prop-types';
import React from 'react';
/*
{"priceToBreak (long)":100.0,"priceToBreak (short)":99.0,"candleDuration":1.0}
 */
export const ConvictionCandleWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'CONVICTION_CANDLE',
    category: 'Setup',
    type: 'Conviction Candle',
    domain: 'Underlying',
  };
  const priceToBreakLong = softOrder['priceToBreak (long)'];
  const priceToBreakShort = softOrder['priceToBreak (short)'];
  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;

  return (
    <Component
      details={details}
      priceToBreak={priceToBreak}
      candleDuration={candleDuration}
      priceToBreakShort={priceToBreakShort}
      priceToBreakLong={priceToBreakLong}
      {...rest}
    />
  );
};

ConvictionCandleWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    candleDuration: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};
